import { DrawerSvcc } from '../../../../components/drawer/DrawerSvcc';
import NewProviderDrawer from './NewProviderDrawer';

export const PROVIDERS_DRAWER_ACTION_VALUES = {
    NEW_PROVIDER: 'new-provider',
    EDIT_PROVIDER: 'edit-provider'
};

const DrawerManager = ({ open, setOpen, selectedSubstance, translate, onlyVisual }: any) => {
    const handleCloseDrawer = () => {
        setOpen('');
    };
    const DrawerInputManager = () => {
        switch (open) {
            case PROVIDERS_DRAWER_ACTION_VALUES.NEW_PROVIDER:
                return (
                    <NewProviderDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedSubstance={selectedSubstance}
                        translate={translate}
                        isEditing={false}
                    />
                );
            case PROVIDERS_DRAWER_ACTION_VALUES.EDIT_PROVIDER:
                return (
                    <NewProviderDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedSubstance={selectedSubstance}
                        translate={translate}
                        isEditing={true}
                        onlyVisual={onlyVisual}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerSvcc open={!!open} onClose={handleCloseDrawer} ancho={560}>
            <DrawerInputManager />
        </DrawerSvcc>
    );
};

export default DrawerManager;
